export function LaserHazardEvaluationFactory() {
    return function LaserHazardEvaluation() {
        this.name = null;
        this.code = null;
        this.id = null;
    }
}
